// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"4eb9acfb","220":"5fc811d7","660":"c2e03cf1","755":"7deddfd8"}[chunkId] + ".chunk.js";
};